
import { useState } from 'react';
import { TransactionFilters as TransactionFiltersType } from "@/types/payments";

export function useTransactionFilterState() {
  const [selectedTab, setSelectedTab] = useState("all");
  const [selectedAccounts, setSelectedAccounts] = useState<string[]>([]);
  
  const [filters, setFilters] = useState<TransactionFiltersType>({
    matched: 'all',
    description: '',
    minAmount: '',
    maxAmount: '',
    startDate: '',
    endDate: '',
  });

  // Handle filter changes
  const handleFilterChange = (key: keyof TransactionFiltersType, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Reset all filters
  const resetFilters = () => {
    setFilters({
      matched: 'all',
      description: '',
      minAmount: '',
      maxAmount: '',
      startDate: '',
      endDate: '',
    });
    setSelectedAccounts([]);
  };

  return {
    selectedTab,
    setSelectedTab,
    selectedAccounts,
    setSelectedAccounts,
    filters,
    handleFilterChange,
    resetFilters
  };
}
